import React, { useCallback, useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Sidebar from "./Sidebar";
import { getPopoverByName } from "../../../utils";
import { selectSubTab } from "../../../store/common/uiSlice";
import { addGraphics } from "../../../canvasUtils";
import { CanvasContext } from "../../editor/CanvasContext";

const AssetsPopover = () => {
  const dispatch = useDispatch();
  const trial = useSelector((state) => state?.user?.details?.data?.trial);

  const thisPopover = getPopoverByName("Assets", trial);
  const shapes = useSelector((state) => state?.assets?.shapes);
  const { canvas } = useContext(CanvasContext);
  const [selectedColor, setSelectedColor] = useState("#000000"); // Default color

  const onTabSelect = useCallback(
    (tabIndex) => {
      dispatch(selectSubTab(tabIndex));
      dispatch(thisPopover.tabs[tabIndex].images());
    },
    [dispatch]
  );

  useEffect(() => {
    // Call onTabSelect with 0 when the component mounts
    onTabSelect(0);
  }, [onTabSelect]);

  const handleClick = ({ file, ...asset }) => {
    return addGraphics(
      canvas,
      { ...asset, url: file, color: selectedColor },
      dispatch
    ); // Pass selectedColor to addGraphics
  };

  const handleColorChange = (color) => {
    setSelectedColor(color);
  };

  return (
    <div className="flex w-full h-full">
      <Sidebar
        titleIcon={"/tool/dashboard/static/images/icons/tools/avatars.svg"}
        title={"Assets"}
        tabs={thisPopover.tabs}
        onTabSelect={onTabSelect}
      />
      <div className="px-2 py-4 w-4/5 bg-gray-100">
        {/* <div className="flex justify-center items-center mb-4">
          <label className="block text-sm font-medium mr-2">Color:</label>
          <input
            type="color"
            className="border rounded-full w-8 h-9 overflow-hidden"
            value={selectedColor}
            onChange={(e) => handleColorChange(e.target.value)}
          />
        </div> */}
        <div className="grid grid-cols-10 gap-8 mt-2 w-full h-full overflow-y-scroll">
          {(shapes || [])?.map((avt, index) => (
            <div
              key={"assets" + index}
              className="w-full rounded flex justify-center items-center cursor-pointer"
              onClick={() => handleClick(avt)}
            >
              <img
                src={avt.file}
                alt={`${index}`}
                className={`max-w-full max-h-full`}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AssetsPopover;
